import type { ImageAdapterFactory } from "./ImageAdapterFactory";
import { type BrowserCanvas, Canvas } from "./Canvas";
import type { ImageAdapter } from "./ImageAdapter";

/**
 * Canvas image adapter factory.
 */
export class CanvasFactory implements ImageAdapterFactory<BrowserCanvas> {
  /**
   * @inheritDoc
   */
  match(resource: unknown): boolean {
    return (
      (typeof HTMLCanvasElement !== "undefined" &&
        resource instanceof HTMLCanvasElement) ||
      (typeof OffscreenCanvas !== "undefined" &&
        resource instanceof OffscreenCanvas)
    );
  }

  /**
   * @inheritDoc
   */
  create(resource: BrowserCanvas): ImageAdapter<BrowserCanvas> {
    return new Canvas(resource);
  }
}
